<script lang="ts">
	import { Models as M } from "@lux-ai/api-interface"
	import { mobileScrollFade } from "responsive"
	import { getLuxAiController } from "../../LuxAIController.svelte"
	import ThemeInstance from "./ThemeInstance.svelte"

	interface Props {
		title: string
		description?: string
		themes: Array<M.Theme>
		activeGenerations: Array<M.ThemeGeneration>
	}

	let { title, description, themes, activeGenerations }: Props = $props()

	const controller = getLuxAiController()
	const getRelevantActiveGeneration = (
		theme: M.Theme,
		activeGenerations: Array<M.ThemeGeneration>,
	) => activeGenerations.find((gen) => gen.theme_id === theme.id)
</script>

<div class="theme-collection">
	<h2 class="collection-title">{title}</h2>
	<p class="section-info">{description}</p>
	<div class="themes" use:mobileScrollFade>
		{#each themes as theme}
			{@const generation = getRelevantActiveGeneration(theme, activeGenerations)}
			<ThemeInstance {theme} activeGeneration={generation} {controller} />
		{/each}
	</div>
</div>

<style>
</style>
